import React from 'react';
import { Alert } from 'react-bootstrap';
import { FaClock, FaPrescription } from 'react-icons/fa';

const OrderLogs = ({ logs }) => {
    const groupedByDate = logs
        ? Object.entries(logs)
            .map(([date, timeGroups]) => ({
                date,
                times: Object.entries(timeGroups)
                    .map(([time, entries]) => ({ time, entries }))
                    .sort((a, b) => new Date(`${date} ${b.time}`) - new Date(`${date} ${a.time}`)),
            }))
            .sort((a, b) => new Date(b.date) - new Date(a.date))
        : [];

    const hasLogs = groupedByDate.length > 0;

    return (
        <div className="timeline p-2 mb-3">
            {hasLogs ? (
                groupedByDate.map(({ date, times }) => (
                    <div key={date} className="timeline-date-group">
                        <div className="timeline-date">
                            {new Date(date).toDateString()}
                        </div>

                        {times.map(({ time, entries }) => (
                            <div key={time} className="timeline-item">
                                {/* <div className="timeline-icon my-2 mr-2">
                                    <FaPrescription />
                                </div> */}
                                <div className="timeline-content-new">
                                    <div className="timeline-title d-flex align-items-center gap-2 mb-2">
                                        <FaClock className="text-muted" />
                                        <span>
                                            {new Date(`${date} ${time}`).toLocaleString('en-US', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}
                                        </span>
                                    </div>
                                    <div className="ps-3 border-start border-2 border-300">
                                        {entries.map((entry, i) => (
                                            <div
                                                key={i}
                                                className={`pb-2 ${i < entries.length - 1 ? 'mb-2 border-bottom border-dashed' : ''}`}
                                            >
                                                <div className="fw-semibold text-800 mb-1">{entry.title}</div>
                                                {entry.old_value !== null &&
                                                    entry.old_value !== undefined &&
                                                    entry.old_value !== "" ? (
                                                    <div className="timeline-desc">
                                                        <span className="text-bold">{entry.field ?? entry.col_changed}</span>
                                                        <span> changed from <em>{entry.old_value}</em> to <em>{entry.new_value}</em></span>
                                                    </div>
                                                ) : entry.new_value ? (
                                                    <div className="timeline-desc">
                                                        <span className="text-bold">{entry.field ?? entry.col_changed}</span>
                                                        <span> has been set to <em>{entry.new_value}</em></span>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="timeline-footer d-flex justify-content-end text-muted small mt-2">
                                        <span>By {entries[0]?.user}</span>
                                        &nbsp;&nbsp;|&nbsp;&nbsp;
                                        <span>
                                            <FaClock className="me-1" />
                                            {new Date(`${date} ${time}`).toLocaleString('en-US', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}
                                        </span>
                                    </div>

                                </div>
                            </div>
                        ))}

                    </div>
                ))
            ) : (
                <Alert variant="info" className="text-center">
                    <strong>No Order Logs Available</strong>
                </Alert>
            )}
        </div>
    );
};

export default OrderLogs;